import { headerLeftIcon, headerMiddleContent } from "../../pages/headerShared";
import Localize from "../../utils/initLocalization";
class ResponsiveNavbar {
    static isOffcanvasScrollable = false;
    static NAVBAR_HEADER_LINKS = [
        {
            title: Localize.translate("common:misc:github"),
            icon: "bi bi-github",
            href: "https://www.github.com/gokacinlar",
        },
    ];
    offcanvas;
    toggleButton;
    toggleButtonIcon;
    handleOffcanvasShown = () => {
        this.setMenuIcon("bi-three-dots-vertical");
    };
    handleOffcanvasHidden = () => {
        this.setMenuIcon("bi-three-dots");
    };
    responsiveMenuToggleButton() {
        return `
            <button
                id="responsiveMenuToggleBtn"
                type="button"
                class="header-responsive-btn bee-color-btn bg-gradient btn btn-lg rounded-5 fs-4 shadow-sm
                    d-flex flex-row align-items-center gap-1"
                title="${Localize.translate("common:header:dayNight")}"
                aria-controls="responsiveHeaderOffcanvas"
                aria-label="${Localize.translate("common:header:dayNight")}"
                data-bs-toggle="offcanvas"
                data-bs-target="#responsiveHeaderOffcanvas"
                aria-expanded="false"
            >
                <i class="bi bi-three-dots"></i>
            </button>
            <div class="responsive-navbar-container">
                ${this.renderResponsiveNavbar()}
            </div>
        `;
    }
    renderResponsiveNavbar() {
        return `
            <div
                class="offcanvas offcanvas-end rounded-start-4"
                tabindex="-1"
                id="responsiveHeaderOffcanvas"
                aria-labelledby="responsiveHeaderOffcanvasTitle"
                data-bs-scroll="${ResponsiveNavbar.isOffcanvasScrollable}"
                data-bs-backdrop="true"
            >
                <div class="offcanvas-header bg-secondary-subtle rounded-start-4">
                    <div class="d-flex flex-wrap align-items-center justify-content-center gap-2">
                        <div>
                            ${headerLeftIcon()}
                        </div>
                        <h5 class="offcanvas-title" id="responsiveHeaderOffcanvasTitle">
                            Derviş Öksüzoğlu
                        </h5>
                    </div>
                    <button
                        id="dismissOffcanvasBtn" type="button" class="btn btn-sm btn-close fs-5 fw-bold"
                        data-bs-dismiss="offcanvas" aria-label="${Localize.translate("common:misc:close")}">
                    </button>
                </div>
                <div id="responsiveHeaderOffCanvasArea" class="offcanvas-body py-1 px-1 mx-0 my-0 overflow-hidden" >
                    <nav id="headerRM" class="h-100 rounded-5 mt-2 shadow-sm d-flex flex-column justify-content-between">
                        <div>
                            <ul class="list-unstyled mb-0 d-flex flex-column align-items-center gap-1 p-2">
                                ${headerMiddleContent()}
                            </ul>
                        </div>

                        <div>
                            <div class="border-1 border-secondary-subtle border-bottom py-2 px-2 d-flex flex-row align-items-center justify-content-between">
                                <div class="d-flex flex-row align-items-center justify-content-center px-2 gap-3">
                                    ${this.renderNavbarHeaderContent()}
                                </div>
                            </div>
                            <div class="mt-4 mb-2">
                                <blockquote class="blockquote text-center text-secondary">
                                    <p>
                                        <em>
                                            ${Localize.translate("common:misc:motto")}
                                        </em>
                                    </p>
                                </blockquote>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        `;
    }
    renderNavbarHeaderContent() {
        return ResponsiveNavbar.NAVBAR_HEADER_LINKS
            .map(({ title, icon, href }) => `
                    <a
                        href="${href}"
                        hreflang="x-default"
                        title="${title}"
                        class="link-offset-2 link-underline link-underline-opacity-0
                            display-2 text-secondary"
                    >
                        <i class="${icon}"></i>
                    </a>
                `)
            .join("");
    }
    setMenuIcon(iconName) {
        if (!this.toggleButtonIcon) {
            return;
        }
        this.toggleButtonIcon.classList.remove("bi-three-dots", "bi-three-dots-vertical");
        this.toggleButtonIcon.classList.add(iconName);
    }
    connectedCallback() {
        this.toggleButton = document.querySelector("#responsiveMenuToggleBtn");
        this.toggleButtonIcon = document.querySelector("#responsiveMenuToggleBtn > i");
        this.offcanvas = document.querySelector("#responsiveHeaderOffcanvas");
        if (!this.toggleButton || !this.toggleButtonIcon || !this.offcanvas) {
            console.warn("Responsive navbar elements were not found.");
            return;
        }
        this.offcanvas.addEventListener("shown.bs.offcanvas", this.handleOffcanvasShown);
        this.offcanvas.addEventListener("hidden.bs.offcanvas", this.handleOffcanvasHidden);
    }
    disconnectedCallback() {
        if (!this.offcanvas) {
            return;
        }
        this.offcanvas.removeEventListener("shown.bs.offcanvas", this.handleOffcanvasShown);
        this.offcanvas.removeEventListener("hidden.bs.offcanvas", this.handleOffcanvasHidden);
    }
}
export default ResponsiveNavbar;
